var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9201 6.0001C22.1501 6.35012 21.32 6.58013 20.46 6.69014C21.34 6.16011 22.0201 5.32007 22.3401 4.31002C21.51 4.81004 20.59 5.16006 19.6199 5.36007C18.8299 4.50003 17.7198 4 16.4598 4C14.1096 4 12.1895 5.9201 12.1895 8.29022C12.1895 8.63024 12.2295 8.96025 12.2996 9.27027C8.73937 9.09026 5.56921 7.38017 3.4591 4.79004C3.08908 5.42007 2.87907 6.16011 2.87907 6.94015C2.87907 8.43023 3.62911 9.7503 4.78917 10.5003C4.07913 10.5003 3.4191 10.3003 2.83907 10.0003C2.83907 10.0003 2.83907 10.0003 2.83907 10.0303C2.83907 12.1104 4.31914 13.8505 6.27924 14.2405C5.91923 14.3405 5.53921 14.3905 5.14919 14.3905C4.87917 14.3905 4.60916 14.3605 4.34914 14.3105C4.88917 16.0006 6.45925 17.2607 8.34935 17.2907C6.88927 18.4507 5.03918 19.1308 3.01908 19.1308C2.67906 19.1308 2.33904 19.1108 1.99902 19.0708C3.89912 20.2908 6.15924 21.0009 8.57936 21.0009C16.4598 21.0009 20.79 14.4605 20.79 8.79025C20.79 8.60024 20.79 8.42023 20.78 8.23022C21.62 7.63019 22.3401 6.87015 22.9201 6.0001Z",
    fill: "#242424"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.d76684cf.svg";
export { ForwardRef as ReactComponent };